import { WrenchTheme } from '@wds/styles';
import { merge } from 'lodash';

const changes = {
	palette: {
		name: 'Default',
		primary: {
			main: '#00bf6f',
			contrast: '#FFFFFF',
			hover: '#05D07B',
			pressed: '#00bf6f',
		},
		success: {
			main: '#00BF6F',
			contrast: '#FFFFFF',
			hover: '#009E5C',
			pressed: '#009E5C',
		},
		muted: {
			main: '#D0D2D3',
			contrast: '#393939',
		},
	},
};

export const DefaultTheme = merge({}, WrenchTheme, changes);
